<template>
  <div class="min-h-screen">
    <request-leave
      :showRequestLeave="showRequestLeave"
      @close="showRequestLeave = false"
      :isSubmitted="isSubmitted"
      :leaveRequestCallback="leaveRequestCallback"
    ></request-leave>

    <edit-request-leave
      :info="requestToEdit"
      :showEditRequest="showEditRequest"
      @close="showEditRequest = false"
      :isSubmitted="isSubmitted"
      :leaveRequestCallback="leaveRequestCallback"
    ></edit-request-leave>
    <div class="bg-white m-3">
      <!-- TAB FOR DYNAMIC LEAVE TYPES -->
      <el-tabs
        type="border-card"
        v-model="activeTab"
        @tab-click="getMyLeaveSummary"
      >
        <el-tab-pane
          v-for="(stat, index) in MyLeaveTypes"
          :key="index"
          :label="stat.LeaveType"
        >
        </el-tab-pane>
      </el-tabs>
      <!-- END FOR DYNAMIC LEAVE TYPES -->

      <div>
        <ve-table :columns="balancesColumns" :tableData="balances"> </ve-table>
      </div>
    </div>
    <div class="bg-white m-3 rounded-md">
      <div class="border-b-0.5 flex justify-between items-center p-3">
        <p class="text-sm font-semibold">My Requests</p>

        <button
          @click="showRequestLeave = true"
          class="bg-primary text-white rounded-full px-3 py-1 text-sm"
        >
          Request Leave
        </button>
      </div>

      <div class="p-2 relative">
        <transition name="fade">
          <div
            v-if="loading"
            class="inset-0 absolute z-50 bg-black bg-opacity-10 w-full"
          >
            <loader class="center-h-v" />
          </div>
        </transition>

        <div class="" v-if="pendingLeaves.length">
          <!-- {{ pendingLeaves }} -->
          <div class="flex items-left my-2 mb-3">
            <el-pagination
              background
              @size-change="handleSizeChange"
              :page-sizes="pageSizes"
              :page-index="pageIndex"
              :page-size="pageSize"
              layout="sizes"
              :total="pendingLeaves.length"
            >
            </el-pagination>

            <!-- search -->
            <input
              v-model="searchInput"
              type="search"
              placeholder="Start typing to search..."
              class="bg-gray-200 w-52 py-1 rounded-md"
            />
            <!-- search -->
          </div>

          <div>
            <ve-table
              v-if="searchInput"
              :columns="columns"
              :table-data="pendingLeaves"
              sort-order="asc"
              :expand-option="expandOption"
              row-key-field-name="rowKey"
            />

            <ve-table
              :columns="columns"
              :tableData="pendingLeaves"
              v-if="!searchInput.length"
            >
            </ve-table>

            <p
              v-if="searchInput.length && pendingLeaves.length === 0"
              class="text-center py-3"
            >
              No results
            </p>

            <p
              v-if="pendingLeaves.length == 0 && !loading && !get_error"
              class="p-1 text-center text-sm w-full bg-gray-100"
            >
              No Leaves found
            </p>
          </div>
        </div>

        <!-- Pagination -->
        <div class="table-pagination text-center mt-2">
          <el-pagination
            v-if="pendingLeaves?.length > 0"
            background
            layout="prev, pager, next"
            :total="totalCount"
            :page-size="pageSize"
            @current-change="handleCurrentChange"
          >
            <!-- :current-page.sync="currentPage4" -->
          </el-pagination>
          <p
            v-if="pendingLeaves?.length === 0 && !loading"
            class="text-center py-3"
          >
            <el-empty :image-size="70" description="No leaves"></el-empty>
          </p>
        </div>
      </div>
    </div>

    <div class="bg-white m-3 rounded-md">
      <div class="border-b-0.5 flex justify-between items-center p-3">
        <p class="text-sm font-semibold">Leave History</p>
      </div>

      <div class="">
        <el-tabs
          type="border-card"
          v-model="currentTab"
          @tab-click="(e) => setTab(e)"
        >
          <el-tab-pane
            v-for="(tab, index) in tabs"
            :key="index"
            :label="tab.name"
            :name="tab.name"
          >
            <div class="" v-if="filteredLeaveHistories.length && !loading">
              <div class="flex items-left my-2 mb-3">
                <el-pagination
                  background
                  @size-change="handleSizeChange"
                  :page-sizes="pageSizes"
                  :page-index="pageIndex"
                  :page-size="pageSize"
                  layout="sizes"
                  :total="filteredLeaveHistories.length"
                >
                </el-pagination>

                <!-- search -->
                <input
                  v-model="searchInput2"
                  type="search"
                  placeholder="Start typing to search..."
                  class="bg-gray-200 w-52 py-1 rounded-md"
                />
                <!-- search -->
              </div>

              <div>
                <ve-table
                  v-if="searchInput2"
                  :columns="
                    currentTab != 'Handover Notes'
                      ? columns
                      : handoverNotesColumns
                  "
                  :table-data="filteredLeaveHistories"
                  sort-order="asc"
                />

                <ve-table
                  :columns="
                    currentTab != 'Handover Notes'
                      ? columns
                      : handoverNotesColumns
                  "
                  :tableData="filteredLeaveHistories"
                  v-if="!searchInput2.length"
                >
                </ve-table>

                <p
                  v-if="
                    searchInput2.length && filteredLeaveHistories.length === 0
                  "
                  class="text-center py-3"
                >
                  No results
                </p>
                <!-- Pagination -->
                <div class="table-pagination text-center mt-2">
                  <el-pagination
                    background
                    layout="prev, pager, next"
                    :total="totalCount"
                    :page-size="pageSize"
                    @current-change="handleCurrentChange"
                  >
                    <!-- :current-page.sync="currentPage4" -->
                  </el-pagination>
                </div>
                <!-- Pagination -->
              </div>
            </div>
            <p v-else class="text-center p-3 text-sm w-full bg-gray-100">
              No Leaves found
            </p>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>

    <review-leave
      :show-review-leave="showReviewLeave"
      @close="showReviewLeave = false"
      :approvalEntries="approvalEntries"
      :leaveDetails="leaveDetails"
      :attachmentUrl="attachmentUrl"
    ></review-leave>

    <el-drawer
      title="Handover Notes"
      :visible.sync="isDrawerOpen"
      :direction="direction"
      :size="isSmallScreen ? '100%' : '40%'"
    >
      <div v-html="notes" class="p-2"></div>
    </el-drawer>
  </div>
</template>

<script>
import requestLeave from "./requestLeave.vue";
import EditRequestLeave from "./editTimeoff.vue";
import ReviewLeave from "./reviewLeave.vue";
import axios from "axios";
import Loader from "@/components/loader/loader.vue";
import { Tabs, TabPane } from "element-ui";

import { mapGetters } from "vuex";
import moment from "moment";
export default {
  name: "MyTimeOff",
  components: {
    requestLeave,
    // AttachmentsViewer,
    "el-tabs": Tabs,
    "el-tab-pane": TabPane,
    Loader,
    EditRequestLeave,
    ReviewLeave,
  },
  data() {
    return {
      isSmallScreen: false,
      isDrawerOpen: false,
      direction: "rtl",
      notes: null,
      attachmentUrl: " ",
      showRequestLeave: false,
      canceledLeaves: [],
      declinedLeaves: [],
      pendingLeaves: [],
      approvedLeaves: [],
      showAttachments: false,
      showReviewLeave: false,
      approvalEntries: null,
      leaveDetails: null,
      success: null,

      showEditRequest: false,
      requestToEdit: null,
      create_success: null,
      create_error: null,
      loading: false,
      reload: false,
      MyLeaveTypes: [],
      activeLabel: "",
      currentTab: "Approved",
      selectedTab: "",
      searchInput2: "",
      filteredLeaveHistories: [],
      searchInput: "",
      MyLeaveTypeStats: [],
      activeTab: 0,
      cancel_error: null,
      cancel_success: null,
      // teamKey: 0,
      // mineKey: 1,
      // page index
      pageIndex: 1,
      // page size
      pageSize: 10,
      pageSizes: [],

      tabs: [
        {
          name: "Approved",
          route: "mine",
        },
        {
          name: "Declined",
          route: "team",
        },
        {
          name: "Canceled",
          route: "mine-canceled",
        },
        {
          name: "Handover Notes",
          route: "handover-notes",
        },
      ],

      balancesColumns: [
        {
          field: "",
          key: "numbering",
          title: "#",
          width: 50,
          headerAlign: "left",
          align: "left",
          renderBodyCell: ({ rowIndex }) => {
            return ++rowIndex;
          },
        },
        {
          field: "Name",
          key: "Name",
          title: "Name",
          headerAlign: "left",
          align: "left",
        },
        {
          field: "Days",
          key: "Days",
          title: "Days",
          headerAlign: "center",
          align: "center",
          renderBodyCell: ({ row }) =>
            row.Days > 0 ? (
              <p class="text-green-500 font-bold text-sm">{row.Days}</p>
            ) : (
              <p class="text-red-500 font-bold text-sm">{row.Days}</p>
            ),
        },
      ],

      balances: [],

      canceledAndDeclinedLeaves: [],
      // Work on this
      expandOption: {
        trigger: "row",
        render: ({ row }) => {
          return (
            <table class="table-auto w-full p-2">
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Line Manager</th>
                </tr>
              </thead>
              <tbody>
                {row.map((row) => {
                  row;
                  return (
                    <tr class="text-center">
                      <td>Description</td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          );
        },
        beforeExpandRowChange: ({ row, rowIndex }) => {
          // alert(JSON.stringify(row, rowIndex));
          this.getDepartments(row.Id, rowIndex);
        },
      },
      // Work on this

      columns: [
        {
          field: "",
          key: "numbering",
          title: "#",
          width: 50,
          headerAlign: "left",
          align: "left",
          renderBodyCell: ({ rowIndex }) => {
            return ++rowIndex;
          },
        },
        {
          field: "LeaveType",
          key: "x",
          title: "Type",
          headerAlign: "left",
          align: "left",
          renderBodyCell: ({ row }) => (
            <div
              class="cursor-pointer text-blue-500"
              onClick={() => {
                this.attachmentUrl = row.Attachment;
                this.approvalEntries = row.ApprovalEntries;
                this.leaveDetails = row;
                this.showReviewLeave = true;
                this.showAttachments = true;
              }}
            >
              {row.LeaveType}
            </div>
          ),
        },
        {
          field: "StartDate",
          key: "a",
          title: "From",
          width: 160,
          headerAlign: "left",
          align: "left",
          renderBodyCell: ({ row }) => (
            <p class="text-left">{this.formatDate(row.StartDate)}</p>
          ),
        },
        {
          field: "EndDate",
          key: "b",
          title: "To",
          width: 160,
          headerAlign: "left",
          align: "left",
          renderBodyCell: ({ row }) => (
            <p class="text-left">{this.formatDate(row.EndDate)}</p>
          ),
        },
        { field: "Period", key: "c", title: "Days" },

        {
          field: "HandoverNotes",
          key: "HandoverNotes",
          title: "Handover Notes",
          width: 160,
          headerAlign: "left",
          align: "center",
          renderBodyCell: ({ row }) => {
            return (
              <button
                onClick={() => {
                  this.isDrawerOpen = true;
                  this.setNotes(row.HandoverNotes);
                }}
                class="px-4 py-2 bg-gray-100 text-gray-700 rounded hover:bg-gray-200 focus:outline-none focus:ring-2 focus:ring-gray-300 transition-colors duration-300"
              >
                View
              </button>
            );
          },
        },

        {
          field: "Description",
          key: "d",
          title: "Description",
          headerAlign: "left",
          align: "left",
          ellipsis: {
            showTitle: true,
          },
          renderBodyCell: ({ row }) => (
            <el-popover
              placement="top-start"
              title={"Leave request from " + row.Name}
              width="300"
              trigger="hover"
              content={row.Description}
            >
              <p
                slot="reference"
                class="cursor-pointer"
                styel="font-size: 0.68rem !important;"
              >
                {row.Description}
              </p>
            </el-popover>
          ),
        },

        {
          field: "Status",
          key: "g",
          title: "Status",
          renderBodyCell: ({ row }) => {
            let status = "";

            switch (row.Status) {
              case "Approved":
                status = (
                  <p class="cursor-pointer text-green-500"> {row.Status}</p>
                );
                break;

              case "Pending":
                status = (
                  <p class="cursor-pointer text-blue-500">{row.Status}</p>
                );
                break;
              case "Declined":
                status = (
                  <p class="cursor-pointer text-red-700">{row.Status}</p>
                );

                break;
              case "Canceled":
                status = (
                  <p class="cursor-pointer text-red-700">{row.Status}</p>
                );
                break;
            }
            return status;
          },
        },

        {
          title: "Action",
          field: "",
          key: "action",
          renderBodyCell: ({ row }) => (
            <ve-popper
              trigger="clickToOpen"
              options={{
                placement: "top",
                modifiers: { offset: { offset: "0,10px" } },
              }}
            >
              <div class="bg-white p-2 shadow-md popper">
                <button
                  class="w-full text-left py-1 px-2 hover:bg-primary hover:text-white"
                  style="boder-radius: 0 !important"
                  onClick={() => this.handleEditButtonClick(row)}
                >
                  Edit
                </button>
                <button
                  class="w-full text-left py-1 px-2 hover:bg-primary hover:text-white"
                  style="boder-radius: 0 !important"
                  onClick={() => this.handleCancelButtonClick(row)}
                >
                  Cancel
                </button>
              </div>

              <button slot="reference">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  id="Outline"
                  viewBox="0 0 24 24"
                  width="20"
                  height="20"
                >
                  <circle cx="12" cy="2" r="2" />
                  <circle cx="12" cy="12" r="2" />
                  <circle cx="12" cy="22" r="2" />
                </svg>
              </button>
            </ve-popper>
          ),
        },
      ],
      columns2: [
        {
          field: "",
          key: "numbering",
          title: "#",
          width: 50,
          headerAlign: "left",
          align: "left",
          renderBodyCell: ({ rowIndex }) => {
            return ++rowIndex;
          },
        },
        {
          field: "LeaveType",
          key: "x",
          title: "Type",
          headerAlign: "left",
          align: "left",
        },
        {
          field: "StartDate",
          key: "a",
          title: "From",
          headerAlign: "left",
          align: "left",
          renderBodyCell: ({ row }) => (
            <p class="">{this.formatDate(row?.StartDate)}</p>
          ),
        },
        {
          field: "EndDate",
          key: "b",
          title: "To",
          headerAlign: "left",
          align: "left",
          renderBodyCell: ({ row }) => (
            <p class="">{this.formatDate(row?.EndDate)}</p>
          ),
        },
        { field: "Period", key: "c", title: "Days" },

        {
          field: "Description",
          key: "d",
          title: "Description",
          headerAlign: "left",
          align: "left",
          ellipsis: {
            showTitle: true,
          },
          renderBodyCell: ({ row }) => (
            <el-popover
              placement="top-start"
              title={"Leave request from " + row.Name}
              width="300"
              trigger="hover"
              content={row.Description}
            >
              <p
                slot="reference"
                class="cursor-pointer"
                styel="font-size: 0.68rem !important;"
              >
                {row.Description}
              </p>
            </el-popover>
          ),
        },

        {
          field: "Reason",
          key: "dd",
          title: "Reason",
          headerAlign: "left",
          align: "left",
          // renderBodyCell: ({ row }) => {
          //   const reason = row.Reason.trim().length ? row.Reason : "None given";
          //   return <p class="text-left">{reason}</p>;
          // },
        },

        {
          field: "LeaveAttachment",
          key: "f",
          title: "Attachment",
          renderBodyCell: ({ row }) => {
            return (
              <button
                onClick={() => {
                  this.attachmentUrl = row.Attachment;
                  this.approvalEntries = row.ApprovalEntries;
                  this.leaveDetails = row;
                  this.showReviewLeave = true;
                }}
                class="bg-primary text-white rounded-full px-3 py-1 text-sm"
              >
                &#128206; View
              </button>
            );
          },
        },
        {
          field: "Status",
          key: "e",
          title: "Status",
          renderBodyCell: ({ row }) => {
            let status = "";
            switch (row.Status) {
              case "Approved":
                status = (
                  <p class="cursor-pointer text-green-500"> {row.Status}</p>
                );
                break;
              case "Pending":
                status = (
                  <p
                    class="cursor-pointer text-blue-500"
                    v-if={row.Status === "Pending"}
                  >
                    {row.Status}
                  </p>
                );
                break;
              case "Declined":
                status = (
                  <p
                    class="cursor-pointer text-red-500"
                    v-if={row.Status === "Declined"}
                  >
                    {row.Status}
                  </p>
                );
                break;
            }
            return <div> {status}</div>;
          },
        },
      ],
      handoverNotesColumns: [
        {
          field: "",
          key: "numbering",
          title: "#",
          width: 50,
          headerAlign: "left",
          align: "left",
          renderBodyCell: ({ rowIndex }) => {
            return ++rowIndex;
          },
        },
        {
          field: "SubmittedBy",
          key: "SubmittedBy",
          title: "Submitted By",
          headerAlign: "left",
          align: "left",
        },
        {
          field: "AssignedTo",
          key: "AssignedTo",
          title: "Assigned To",
          headerAlign: "left",
          align: "left",
          ellipsis: {
            showTitle: true,
          },
          renderBodyCell: ({ row }) => (
            <el-popover
              placement="top-start"
              title={"Handover Notes Assigned To"}
              width="300"
              trigger="hover"
            >
              <ul class="cursor-pointer" style="font-size: 0.68rem !important;">
                {row.AssignedTo.map((item, index) => (
                  <li key={index} class="flex items-center my-3">
                    <el-avatar
                      size="small"
                      src={item.AvatarURL}
                      style="margin-right: 8px;"
                    ></el-avatar>
                    <span>{item.Name}</span>
                  </li>
                ))}
              </ul>
              <template slot="reference">
                <ul
                  class="cursor-pointer"
                  style="font-size: 0.68rem !important;"
                >
                  {row.AssignedTo.map((item, index) => (
                    <li key={index} class=" items-center">
                      <span>{item.Name}</span>
                    </li>
                  ))}
                </ul>
              </template>
            </el-popover>
          ),
        },

        {
          field: "ApprovedBy",
          key: "ApprovedBy",
          title: "Approved By",
          headerAlign: "left",
          align: "left",
          ellipsis: {
            showTitle: true,
          },
          renderBodyCell: ({ row }) => (
            <el-popover
              placement="top-start"
              title={"Approved By"}
              width="300"
              trigger="hover"
            >
              <ul class="cursor-pointer" style="font-size: 0.68rem !important;">
                {row.ApprovedBy.map((item, index) => (
                  <li key={index} class="flex items-center my-3">
                    <el-avatar
                      size="small"
                      src={item.AvatarURL}
                      style="margin-right: 8px;"
                    ></el-avatar>
                    <span>{item.Name}</span>
                  </li>
                ))}
              </ul>
              <template slot="reference">
                <ul
                  class="cursor-pointer"
                  style="font-size: 0.68rem !important;"
                >
                  {row.AssignedTo.map((item, index) => (
                    <li key={index} class=" items-center">
                      <span>{item.Name}</span>
                    </li>
                  ))}
                </ul>
              </template>
            </el-popover>
          ),
        },

        {
          field: "DateApproved",
          key: "DateApproved",
          title: "Date Approved",
          headerAlign: "left",
          align: "left",
          renderBodyCell: ({ row }) => (
            <p class="">{this.formatDate(row?.StartDate)}</p>
          ),
        },
        {
          field: "LeaveType",
          key: "x",
          title: "Leave Type",
          headerAlign: "left",
          align: "left",
        },

        {
          field: "Attachment",
          key: "Notes",
          title: "Notes",
          renderBodyCell: () => {
            return (
              <button
                onClick={() => {
                  this.isDrawerOpen = true;
                  this.setNotes();
                }}
                class="bg-primary text-white rounded-full px-3 py-1 text-sm"
              >
                View
              </button>
            );
          },
        },
      ],
      tableData: [],
      handoverNotesData: [],
    };
  },
  computed: {
    ...mapGetters([
      "getOrganization",
      "getToken",
      "getUserType",
      "getCurrentEmployeeId",
      "getVersion",
    ]),

    filteredColumns() {
      const approvedCount = this.leaves.filter(
        (leave) => leave.Status === "Approved"
      ).length;
      const declinedCount = this.leaves.filter(
        (leave) => leave.Status === "Declined"
      ).length;

      return this.columns.filter((column) => {
        if (
          column.field === "Action" &&
          (approvedCount === this.leaves.length ||
            declinedCount === this.leaves.length)
        ) {
          return false;
        }
        return true;
      });
    },
    // table data
    currentTableData() {
      const { pageIndex, pageSize } = this;
      return this.tableData.slice(
        (pageIndex - 1) * pageSize,
        pageIndex * pageSize
      );
    },
    // total count
    totalCount() {
      return this.tableData.length;
    },
  },

  created() {
    this.getMyLeaveTypes(this.currentTab);
    this.getMyLeaves(this.currentTab);
    this.setPageSizes();
    this.searchInput2 = this.activeLabel;
    this.setTab("Approved");

    // Call the method to fetch data for the "Approved" tab
    // this.fetchApprovedTabData();
  },

  mounted() {
    // Call your API to fetch leave types data
    this.getMyLeaveTypes();
    // Get summary data for the first leave type if MyLeaveTypes is not empty
    if (this.MyLeaveTypes.length > 0) {
      const { LeaveTypeId } = this.MyLeaveTypes[0];
      this.getMyLeaveSummary(LeaveTypeId);
    }

    // Check screen size on component mount
    this.checkScreenSize();

    // Listen for resize events to dynamically update screen size
    window.addEventListener("resize", this.checkScreenSize);
  },
  beforeDestroy() {
    // Remove resize event listener on component destroy
    window.removeEventListener("resize", this.checkScreenSize);
  },
  watch: {
    MyLeaveTypes: {
      handler(newVal) {
        if (newVal.length > 0) {
          const { LeaveTypeId } = newVal[0];
          this.getMyLeaveSummary(LeaveTypeId);
        }
      },
      immediate: true, // Invoke the handler immediately when the component is created
    },
    currentTab: {
      handler(newVal) {
        this.getMyLeaves(newVal);
      },
      immediate: true,
    },
  },

  methods: {
    checkScreenSize() {
      // Determine screen size based on window width
      this.isSmallScreen = window.innerWidth <= 768; // Adjust 768 according to your breakpoint
    },
    setNotes(notes) {
      this.notes = notes ? notes : "No handover notes were found";
    },
    updateLeaveList(currentTab) {
      switch (currentTab) {
        case "Declined":
          this.filteredLeaveHistories = this.declinedLeaves;
          break;
        case "Canceled":
          this.filteredLeaveHistories = this.canceledLeaves;
          break;
        case "Approved":
          this.filteredLeaveHistories = this.approvedLeaves;
          break;
        case "Pending":
          this.filteredLeaveHistories = this.pendingLeaves;
          break;
        case "Handover Notes":
          this.filteredLeaveHistories = this.handoverNotesData;
          break;
        default:
          break;
      }
    },
    async fetchApprovedTabData() {
      this.getMyLeaves(this.currentTab); // Once data is fetched, set the "Approved" tab as the active tab
      this.setTab("Approved");
    },

    leaveRequestCallback(message, isSuccess) {
      if (isSuccess) {
        this.create_success = message;
      } else {
        this.create_error = message;
      }
      setTimeout(() => {
        this.cancel_error = null;
        this.create_success = null;
      }, 2000);
    },
    isSubmitted() {
      this.showEditRequest = false;
      this.getMyLeaves(this.currentTab);
    },
    refresh() {
      this.getMyLeaveTypes(this.currentTab);
      this.updateLeaveList(this.selectedTab);
      this.getMyLeaves(this.currentTab);
      this.setPageSizes();
      this.searchInput2 = this.activeLabel;
    },
    setTab(event) {
      // alert(JSON.stringify(this.tableData));
      let tabId;
      if (event["$el"]) {
        const { id } = event["$el"];
        tabId = id;
      } else {
        tabId = event;
      }
      tabId = tabId.includes("-") ? tabId.split("-")[1] : tabId;
      switch (tabId) {
        case "Approved":
          this.selectedTab = "Approved";
          this.updateLeaveList("Approved");
          break;
        case "Pending":
          this.selectedTab = "Pending";
          this.updateLeaveList("Pending");
          break;
        case "Declined":
          this.selectedTab = "Declined";
          this.updateLeaveList("Declined");
          break;
        case "Canceled":
          this.selectedTab = "Canceled";
          this.updateLeaveList("Canceled");
          break;
      }
    },

    handleSizeChange(newPageSize) {
      this.pageSize = newPageSize;
    },
    handleCurrentChange(currentPage) {
      this.pageIndex = currentPage;
    },
    setPageSizes() {
      // Generate the page sizes array using a loop
      for (let i = 1; i <= 10; i++) {
        this.pageSizes.push(this.pageSize * i);
      }
    },
    // page number change
    pageNumberChange(pageIndex) {
      this.pageIndex = pageIndex;
    },

    // page size change
    pageSizeChange(pageSize) {
      this.pageIndex = 1;
      this.pageSize = pageSize;
    },
    handleEditButtonClick(request) {
      // Handle the button click for the edit button
      this.requestToEdit = {
        ...request,
        StartDate: moment(request.StartDate).format("YYYY-MM-DD"), // override StartDate with formatted value
        EndDate: moment(request.EndDate).format("YYYY-MM-DD"), // override EndDate with formatted value
      };

      this.showEditRequest = true;
    },

    formatLeaveTypeStats(stats) {
      // Iterate over the key-value pairs of the stats object and map them to an array of objects
      return Object.entries(stats).map(([key, value]) => {
        // Split the key at the uppercase letters and join with a space to create the Name property
        const name = key.split(/(?=[A-Z])/).join(" ");
        // Create the Days property with the corresponding value for the key
        const days = value;
        // Return an object with the Name and Days properties
        return { Name: name, Days: days };
      });
    },

    // /{organization}/timeoff/leave/type/{leaveTypeId}/v1/summary
    getMyLeaveSummary(leaveTypeId) {
      // The active tab index is available as this.activeTab
      const activeTabIndex = this.activeTab;

      // Get the label of the active tab from the MyLeaveTypes array using the active tab index
      const activeTabLabel = this.MyLeaveTypes[activeTabIndex];
      const { LeaveTypeId } = activeTabLabel;
      this.activeLabel = activeTabLabel.LeaveType;
      // Call your API to fetch panel data for the active tab

      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
        },
      };
      axios
        .get(
          `${this.getOrganization}/timeoff/leave/type/${
            LeaveTypeId ? LeaveTypeId : leaveTypeId
          }/v1/summary`,
          options
        )
        .then(
          (response) => {
            this.loading = false;
            if (response.data.StatusCode == 200) {
              this.MyLeaveTypeStats = response.data.Data;
              this.balances = this.formatLeaveTypeStats(this.MyLeaveTypeStats);
              // Find the Pending Approval and Available entries
              let pendingApproval = this.balances.find(
                (entry) => entry.Name === "Pending Approval"
              );
              let available = this.balances.find(
                (entry) => entry.Name === "Available"
              );

              // Add Pending Approval days to Available days if both exist
              if (pendingApproval && available) {
                available.Days += pendingApproval.Days;
              }
            } else {
              this.get_error = response.data.StatusMessage;
            }
          },
          (error) => {
            this.loading = false;
            this.error = error.message;
          }
        );
    },

    async handleCancelButtonClick(row) {
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
          "Content-Type": "application/json", // Set the content type to multipart form data
        },
        data: {
          TimeoffRequestId: row.Id,
        },
      };

      try {
        const response = await axios.delete(
          `${this.getOrganization}/timeoff/${this.$ApiVersion}/cancel`,
          options
        );

        this.loading = true;
        if (response.data.StatusCode === 200) {
          this.loading = false;
          this.cancel_success = response.data.StatusMessage;
          this.$notify({
            title: "Success",
            message: response.data.StatusMessage,
            type: "success",
          });
          this.refresh();
          setTimeout(() => {
            this.cancel_success = null;
          }, 2000);
        } else {
          this.loading = false;
          this.cancel_error = response.data.StatusMessage;
          setTimeout(() => {
            this.cancel_error = null;
          }, 2000);
        }
      } catch (error) {
        this.loading = false;
        this.cancel_error = error.message;
        setTimeout(() => {
          this.cancel_error = null;
        }, 2000);
      }
    },

    // /{organization}/timeoff/me/leave/type/v1/request
    getMyLeaveTypes() {
      this.loading = true;
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
        },
      };
      // const EmployeeId = this.getCurrentEmployeeId;

      axios
        .get(
          `${this.getOrganization}/timeoff/me/leave/type/${this.$ApiVersion}/request`,
          options
        )
        .then(
          (response) => {
            this.loading = false;
            if (response.data.StatusCode == 200) {
              this.MyLeaveTypes = response.data.Data.filter(
                (leave) => leave.LeaveType != null
              ).sort(this.sortLeaves);
            } else {
              this.get_error = response.data.StatusMessage;
            }
          },
          (error) => {
            this.loading = false;
            this.error = error.message;
          }
        );
    },
    formatDate(dateStr) {
      return moment(dateStr).format("DD/MM/YYYY");
    },
    async getMyLeaves() {
      this.loading = true;
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
          accept: "*/*",
        },
      };

      axios
        .get(
          `${this.getOrganization}/timeoff/me/${this.$ApiVersion}/request`,
          options
        )
        .then(
          (response) => {
            this.loading = false;
            if (response.status == 200) {
              const data = response.data.Data.sort(
                (a, b) => new Date(a.StartDate) - new Date(b.StartDate)
              );
              this.pendingLeaves = data.filter(
                (timeoff) => timeoff.Status === "Pending"
              );

              this.approvedLeaves = response.data.Data.sort(
                (a, b) => new Date(b.StartDate) - new Date(a.StartDate)
              ).filter((timeoff) => timeoff.Status === "Approved");

              this.canceledLeaves = data.filter(
                (timeoff) => timeoff.Status === "Canceled"
              );

              this.declinedLeaves = data.filter(
                (timeoff) => timeoff.Status === "Declined"
              );
              this.updateLeaveList(this.currentTab);
            } else {
              this.create_error = response.data.StatusMessage;
            }
          },
          (error) => {
            this.loading = false;
            this.create_error = error.message;
          }
        );
    },

    sortLeaves(a, b) {
      const aLeaveType = a.LeaveType.toLowerCase();
      const bLeaveType = b.LeaveType.toLowerCase();

      if (aLeaveType.includes("annual") && !bLeaveType.includes("annual")) {
        return -1; // "Annual Leave" comes first
      } else if (
        !aLeaveType.includes("annual") &&
        bLeaveType.includes("annual")
      ) {
        return 1; // "Annual Leave" comes first
      }

      return aLeaveType.localeCompare(bLeaveType); // Sort alphabetically
    },
  },
};
</script>

<style>
.el-tabs__item.is-top.is-active {
  background-color: rgba(222, 164, 44, var(--tw-bg-opacity)) !important;
  color: "#fff" !important;
}

.el-tabs--border-card > .el-tabs__header .el-tabs__item.is-active {
  color: #fff;
}

.el-tabs--border-card
  > .el-tabs__header
  .el-tabs__item:not(.is-disabled):hover {
  color: #fff;
}

.el-tabs__item.is-top:hover {
  background-color: rgba(222, 164, 44, var(--tw-bg-opacity)) !important;
}
</style>
